import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/inbox/$ticketId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/tickets/$ticketId",
      params: { ticketId: params.ticketId },
    });
  },
});
